import React from 'react';

interface MarqueeComponentProps {
    texts: { name: string, notificationId: string }[];
    onTextClick: (notificationId: string) => void;
}

export const MarqueeNotifications: React.FC<MarqueeComponentProps> = ({
    texts,
    onTextClick
}) => {

    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            {texts.map((text, index) => (
                <React.Fragment key={text.notificationId}>
                    <span
                        onClick={() => onTextClick(text.notificationId)}
                        style={{ cursor: 'pointer', marginRight: '20px', color: "blue" }}
                    >
                        {text.name}
                    </span>
                    {index < texts.length - 1 && <span style={{ marginRight: '20px' }}> | </span>}
                </React.Fragment>
            ))}
        </div>
    );
}
